export default __webpack_public_path__ + "assets/webgl/flashlight.97be956b.jpg";